import React, { useContext, useState } from "react";
import { SocketContext } from "../../context/SocketContext";
import { AuthContext } from "../../context/AuthContext";
import { Button, Card, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Styles, SQuestion, SAnswer } from "./Questions.styles";
import { Reactions } from "../Chat/Reactions";
import { MediaContext } from "../../context/MediaContext";
import { onDeleteMessage } from "../../utils/Alert";

const Questions = ({ replyClick }) => {
  const { chatMessages } = useContext(SocketContext);

  return (
    <Styles>
      <Col className="content">
        {Object.values(chatMessages)
          .filter((m) => m.isQuestion)
          .map((item, index) => {
            const children = Object.values(chatMessages).filter((m) => m.parentMsg === item.uuid);

            return <Question key={index} message={item} children={children} replyClick={replyClick} />;
          })}
      </Col>
    </Styles>
  );
};

const Question = ({ message, children, replyClick = null }) => {
  const { t } = useTranslation("", { keyPrefix: "components.chat" });

  const { currentUser } = useContext(AuthContext);
  const { setVideoTs, setSlideNumber, setIsFollowing } = useContext(MediaContext);
  const { sendSocketEvent } = useContext(SocketContext);
  const [showAnswers, setShowAnswers] = useState(false);

  const {
    uuid,
    text,
    updatedAt,
    videoTs,
    deleted,
    slideNumber,
    sender: { lastName, firstName },
  } = message;

  // date without seconds
  const when = new Date(updatedAt).toLocaleTimeString(t.i18n, {
    hour: "2-digit",
    minute: "2-digit",
  });

  const getReactionValues = () => {
    const values = new Array(5).fill(0).map(() => {
      return { value: 0, userReacted: false };
    });

    Object.values(message.reactions || {}).forEach((reaction) => {
      values[reaction.value - 5].value += 1;

      if (reaction.email === currentUser.email) {
        values[reaction.value - 5].userReacted = true;
      }
    });

    return values;
  };

  const deleteMsg = () => {
    onDeleteMessage({ uuid }, sendSocketEvent);
  };

  return (
    <SQuestion>
      <Card>
        <Card.Body>
          <Col className="d-flex flex-column px-1">
            <span className="w-auto message-title fs-6 fw-bold mt-3">{`${lastName} ${firstName}`}</span>
            {deleted ? <span className="fst-italic">{t("qst_deleted")}</span> : <span>{text}</span>}
            <Row>
              <div className="d-flex flex-row justify-content-between align-items-center mt-2">
                {!deleted && (
                  <span className="w-auto text-nowrap message-time fs-6 me-auto">
                    <Reactions message={message} values={getReactionValues()} dark={true} />
                  </span>
                )}
                {children.length > 0 && (
                  <Button className="show-answers" onClick={() => setShowAnswers((v) => !v)}>
                    <i className="fas fa-reply me-1"></i>
                    {children.length}
                  </Button>
                )}
              </div>
              <span className="w-auto text-nowrap message-time fs-6 position-absolute top-0 pb-2 end-0">
                {when}
                {videoTs != null && (
                  <i className="fas fa-video ms-2 reference-buttons" onClick={() => setVideoTs(videoTs)} />
                )}
                {!deleted && <i className="fas fa-trash ms-2 reference-buttons" onClick={() => deleteMsg()} />}
                {slideNumber !== null && slideNumber > 0 && (
                  <i
                    className="fas fa-file-pdf ms-2 reference-buttons"
                    onClick={() => {
                      setIsFollowing(false);
                      setSlideNumber(slideNumber);
                    }}
                  />
                )}
                {replyClick && (
                  <i className="fas fa-reply ms-2 reference-buttons" onClick={() => replyClick(message.uuid)} />
                )}
              </span>
            </Row>
            {children.length > 0 && showAnswers && (
              <Row className="w-100">
                <div className="answers">
                  {children.map((answer, index) => (
                    <Answer key={answer.uuid} answer={answer} isFirst={index === 0} />
                  ))}
                </div>
              </Row>
            )}
          </Col>
        </Card.Body>
      </Card>
    </SQuestion>
  );
};

const Answer = ({ answer, isFirst }) => {
  const {
    text,
    videoTs,
    slideNumber,
    updatedAt,
    sender: { lastName, firstName },
  } = answer;

  const { t } = useTranslation("", { keyPrefix: "components.chat" });
  const { currentUser } = useContext(AuthContext);
  const { setVideoTs, setSlideNumber, setIsFollowing } = useContext(MediaContext);

  const when = new Date(updatedAt).toLocaleTimeString(t.i18n, {
    hour: "2-digit",
    minute: "2-digit",
  });

  const getReactionValues = () => {
    const values = new Array(5).fill(0).map(() => {
      return { value: 0, userReacted: false };
    });

    Object.values(answer.reactions || {}).forEach((reaction) => {
      values[reaction.value - 5].value += 1;

      if (reaction.email === currentUser.email) {
        values[reaction.value - 5].userReacted = true;
      }
    });

    return values;
  };
  return (
    <SAnswer isFirst={isFirst}>
      <span className="w-auto fs-6 fw-bold mt-3">{`${lastName} ${firstName}`}</span>
      <span>{text}</span>
      <span className="w-auto text-nowrap fs-6 me-auto">
        <Reactions message={answer} values={getReactionValues()} dark={true} />
      </span>
      <span className="w-auto text-nowrap message-time fs-6 position-absolute top-0 pb-2 end-0">
        {when}
        {videoTs != null && <i className="fas fa-video ms-2 reference-buttons" onClick={() => setVideoTs(videoTs)} />}
        {slideNumber !== null && slideNumber > 0 && (
          <i
            className="fas fa-file-pdf ms-2 reference-buttons"
            onClick={() => {
              setIsFollowing(false);
              setSlideNumber(slideNumber);
            }}
          />
        )}
      </span>
    </SAnswer>
  );
};
export default Questions;
